<template>
	<div class="landing-healtcare" v-if="pageHealthCare.elements">
		<!-- content home -->
		<hero :props="pageHealthCare.elements"  :heroHome="false"></hero>

		<section class="cases" v-in-viewport="">
				<div class="inside">
					<div class="row">



						<template class="" v-for="cases in pageHealthCare.elements.cases.value">

								<div class="case-item col-xs-12 col-md-4" >
									<div class="inner-text">
										<div class="logo outside">
											<!--<img :src="modularContent[cases].elements.logo.value[0].url" alt="modularContent[cases].elements.title.value">-->
											<h4>{{modularContent[cases].elements.case.value}}</h4>
										</div>

										<div class="left-content">
											<div class="logo _inside">
												<!--<img :src="modularContent[cases].elements.logo.value[0].url" alt="modularContent[cases].elements.title.value">-->
												<h4>{{modularContent[cases].elements.case.value}}</h4>
											</div>

											<div class="info" v-html="modularContent[cases].elements.text.value">

											</div>
										</div>

										<div class="right-content">
											<img :src="modularContent[cases].elements.picture.value[0].url" alt="" class="o-fit">
										</div>
									</div>
								</div>

						</template>
					</div>
				</div>
		</section>

		<section class="content-articles" v-in-viewport="">
			<div class="inside">
				<h2 class="text-center" v-in-viewport="">{{pageHealthCare.elements.title_content.value}}</h2>
				<p class="text-center container">{{pageHealthCare.elements.subtitle_content.value}}</p>

				<div class="row">
					<div class="copy col-xs-12 col-md-6" >
						<div class="inner-text left-content">
							<img :src="pageHealthCare.elements.image_content.value[0].url" alt="" class="o-fit">
						</div>
					</div>
					<div class="detail col-xs-12 col-md-6">
						<div class="inner-text right-content" v-html="pageHealthCare.elements.main_content.value">

						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Contact Form  -->
		<contact :contactFormInfo="contactFormInfo"></contact>

		<div class="clearfix"></div>

		<section class="contact-section">
			<div class="inside">
				<div class="row">
					<div class="copy col-xs-12 col-md-6 col-lg-8" >
						<h3>About Marcus Thomas LLC</h3>
						<p>Marcus Thomas LLC, with 300 professionals in its offices in Cleveland and Cincinnati, Ohio, Buenos Aires, Argentina and Santiago, Chile, is among America’s leading independent advertising agencies. Marcus Thomas is a recognized leader in digital strategy and technology; is Ohio’s largest media planning and buying agency; has been recognized by the Content Marketing Institute as one of the world’s leading content marketing agencies; and is regularly honored for its award-winning creative and social media campaigns.</p>
						<router-link to="/solutions" tag="button" class="btn_orange">CAPABILITIES</router-link>
					</div>

					<div class="image col-xs-12 col-md-6 col-lg-4">
						<img src="/dist/about.png" alt="" class="o-fit">
					</div>

				</div>
			</div>
		</section>
		
		<!-- Footer -->
		<Footer></Footer>

	</div>
</template>


<script>
	import seoModule from '../mixins/seoModule.js';
	import contactForm from '../components/contact-form-salesforce.vue';
	import hero from '../components/hero-healthcare.vue';
	import Footer from '../layout/footer-component.vue';

		require('../assets/img/about.png');

	export default{
		name:'Home',
		data () {
			return {
				pageHealthCare: [],
				modularContent:[],
				contactFormInfo: [],
			}
		},
		created:function(){
			document.body.classList.add("healtcare");
			this.loadHealthCareData();
		},
		mounted: function() {
			let _this = this;
			setTimeout(function(){
				$('.st-sticky-share-buttons').removeClass('st-sticky-share-buttons-show');
			},500);
		},
		methods: {
			loadHealthCareData() {
				this.$http.get("/src/data_jsons/healthcare_data.json").then((response) => {
					let formInfo = response.body.items[0].elements.contact_form.value[0];
					this.pageHealthCare = response.body.items[0];
					this.modularContent = response.body.modular_content;
					this.contactFormInfo = response.body.modular_content[formInfo].elements;
					
					// Show footer after loading data
					setTimeout(function () {
						$("#footer").show();
					}, 500);
				});
			}
		},
		computed: {
			version: function(){
				return 'v2';
			}
		},
		components:{
			'hero':hero,
			'Footer':Footer,
			'contact': contactForm
		},
		mixins:[seoModule]
	}
</script>



// WEBPACK FOOTER //
// HealthCare.vue?5303b92e